import bing from './bing';
import google from './google';
import googleanalytics from './googleanalytics';
import kinesis from './kinesis';
import facebook from './facebook';
import kissmetrics from './kissmetrics';

const Trackers = { google, googleanalytics, facebook, bing, kinesis, kissmetrics };

/**
 * A dash of CSS styling wrapped around the analytics event
 *
 * @kind function
 * @name log
 * @param {String} label The event being logged (each script sets this uniquely)
 */
export function log(label, ...restOfArgs) {
  // eslint-disable-next-line no-console
  console.log(
    `%c${label || '[event]'}`,
    'border-radius: 3px; color: white; font-weight: bold; font-size: 15px; font-face: Helvetica; background-color: #00aed9; border: 1px solid #fbf2de; text-shadow: 1px 1px 4px #757989; padding: 4px 8px;',
    ...restOfArgs
  );
}

/**
 * Processes each analytics config by fetching the remote script (by its `name`
 * prop) and then creating an instance of Tracker from it. The collection of
 * analytics configs is then returned with those Tracker instances as part of
 * each config.
 *
 * @kind function
 * @name configureAnalyticsScripts
 * @sig {k: v} -> [{k: v} ...]
 * @param {Object} config An objec of analytics config objects, each containing either an `id` (that corresponds to a paid enterprise account) or a `url` to post the event to (for analytics services we roll oursevles)
 * @param {Boolean} [debug=false] Whether or not to log events to the browser console as they are captured
 * @param {Boolean} [noPublish=false] Whether or not to send events to the remote services (defaults to `false` of course)
 * @returns {Object[]} an array of instantiated analytics tracking clients
 */
function configureAnalyticsScripts(config = {}, debug = false, noPublish = false) {
  return Object.keys(config).map(name => {
    const createTracker = Trackers[name];
    let tracker;
    if (createTracker) {
      tracker = createTracker(config[name], debug === true && log, noPublish);
    }
    return { ...config, name, tracker };
  }).filter(x => x.tracker);
}

export default configureAnalyticsScripts;
